import { LtIcons } from "@landtechnologies/icons/font/lt-icons";
import clsx from "clsx";

export interface NavbarItemIconProps {
  icon: `${LtIcons}`;
  alwaysShow?: boolean;
  noPaddings?: boolean;
}

export function NavbarItemIcon({ icon, alwaysShow = false, noPaddings = false }: NavbarItemIconProps) {
  return <i className={clsx("block text-xl", `icon-${icon}`, !alwaysShow && "md:hidden", !noPaddings && "pt-2")} />;
}
